"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketCenterNonComplianceCaseStatus = exports.NonComplianceCaseType = void 0;
var NonComplianceCaseType;
(function (NonComplianceCaseType) {
    NonComplianceCaseType["BARCODE_NOT_IN_SYSTEM"] = "barcode-not-in-system";
})(NonComplianceCaseType = exports.NonComplianceCaseType || (exports.NonComplianceCaseType = {}));
var TicketCenterNonComplianceCaseStatus;
(function (TicketCenterNonComplianceCaseStatus) {
    TicketCenterNonComplianceCaseStatus["CREATED"] = "created";
    TicketCenterNonComplianceCaseStatus["TODO"] = "todo";
    TicketCenterNonComplianceCaseStatus["CLOSED"] = "closed";
})(TicketCenterNonComplianceCaseStatus = exports.TicketCenterNonComplianceCaseStatus || (exports.TicketCenterNonComplianceCaseStatus = {}));
//# sourceMappingURL=TicketCenterResponses.js.map